import { Component, OnInit, ElementRef, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
declare var jQuery: any;

@Component({
  selector: 'price-filter',
  templateUrl: './price-filter.component.html',
  styleUrls: ['./price-filter.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PriceFilterComponent),
      multi: true
    }
  ]
})
export class PriceFilterComponent implements ControlValueAccessor {
  @Input() value: string;
  propagateChange = (_: any) => { };

  writeValue(value: any): void {
    if (value !== undefined) {
      // If a value is provided to the Component
      if (this.value && String(this.value).length) { // Is Not an Empty String
        this.value = value;
      }
    }
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void {
  }


  constructor(private elRef: ElementRef) { }

  ngOnInit() {
    let minPrice: number = 0;
    let maxPrice: number = 20000;
    jQuery(this.elRef.nativeElement).find('#price-filter').slider({
      range: true,
      min: minPrice,
      max: maxPrice,
      values: [minPrice, maxPrice],
      step: 100,
      slide: function (event, ui) {
        this.propagateChange(ui.values[0] + "-" + ui.values[1]);
        jQuery(this.elRef.nativeElement).find('#slider-indicator').html(ui.values[0] + " - " + ui.values[1]);
      }.bind(this)
    });

    jQuery(this.elRef.nativeElement).find('.ui-slider-range').css('background', '#3286CC'); // Can't change color in CSS, so we manually set it here.
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/price-filter/price-filter.component.ts